import { render, staticRenderFns } from "./DocEditForm.vue?vue&type=template&id=238ccf5a&"
import script from "./DocEditForm.vue?vue&type=script&lang=js&"
export * from "./DocEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DocEditForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports